export default __webpack_public_path__ + "static/Icon-hand-heart-0255b178b5a8623e4f8b66bfccdb73b8.svg";